/* eslint-disable no-await-in-loop */
import { message } from 'antd';

import { POST, GET } from 'src/network/apiHandler';
import config from 'src/globals';
import {
  GET_INVOICE_NUMBER_CONSIGNMENTS,
  INVOICE_SEARCH,
  UPDATE_INVOICE_POD_LIST,
  MARK_CONSIGNMENT_DELIVERED,
  MARK_CONSIGNMENT_UNDELIVERED,
  MARK_CONSIGNMENT_PICKUP_COMPLETED,
  MARK_CONSIGNMENT_NOT_PICKED_UP,
  INVOICE_SEARCH_IST,
  MARK_CONSIGNMENT_DELIVERED_IST,
  MARK_CONSIGNMENT_UNDELIVERED_IST,
} from 'src/api/routes';
import {
  SET_INVOICE_NUMBER_CONSIGNMENT,
  SET_INVOICE_NUMBER_DATA,
  SET_INVOICE_NUMBER_LOADER,
  SET_INVOICE_NUMBER_POD_LIST,
  SET_INVOICE_REQUEST_LOADER,
  SET_UPLOAD_FILE_LOADER,
  SET_SELECTED_INVOICE_CN_KEYS,
  SET_FILTERED_INVOICE_CNS,
  SET_PIECE_LEVEL_ACTIONS,
  SET_EVENT_TIMESTAMP,
} from 'src/common/actions/constants';
import { getInvoiceNumbersForIST, markConsignmentsAsDeliveredForIST, markConsignmentsAsUndeliveredForIST } from './DeliveryAcknowledgement.api';
import { uploadPodFiles } from './DeliveryAcknowledgement.utils';

const { API_BASE_URL } = config;

export const setSelectedRowKeys = (data) => async (dispatch, getState) => {
  dispatch({
    type: SET_SELECTED_INVOICE_CN_KEYS,
    data,
  });
};

export const setPieceLevelActions = (data) => async (dispatch, getState) => {
  dispatch({
    type: SET_PIECE_LEVEL_ACTIONS,
    data,
  });
};

export const setEventTimestamp = (data) => async (dispatch, getState) => {
  dispatch({
    type: SET_EVENT_TIMESTAMP,
    data,
  });
};

export const getInvoiceConsignmentList = (data) => async (dispatch, getState) => {
  dispatch({
    type: SET_INVOICE_REQUEST_LOADER,
    data: true,
  });
  const response = await POST(API_BASE_URL + GET_INVOICE_NUMBER_CONSIGNMENTS, data);
  if (response.isSuccess) {
    const cnData = response.data;
    let podList = [];
    if (cnData && Array.isArray(cnData) && cnData.length) {
      podList = cnData[0].vendor_image_url_list;
    }
    dispatch({
      type: SET_INVOICE_NUMBER_CONSIGNMENT,
      data: {
        consignments: cnData,
        invoiceNumber: data.number,
        podList,
        searchType: data.type,
      },
    });
  } else {
    message.error(response.errorMessage);
  }
  dispatch({
    type: SET_INVOICE_REQUEST_LOADER,
    data: false,
  });
};

export const updateInvoicePodList = (data) => async (dispatch, getState) => {
  const { deliveryAcknowledgement } = getState();

  if (!deliveryAcknowledgement.uploadLoading) {
    dispatch({
      type: SET_UPLOAD_FILE_LOADER,
      data: true,
    });
  }

  const response = await POST(API_BASE_URL + UPDATE_INVOICE_POD_LIST, {
    reference_number_list: deliveryAcknowledgement.selectedRowKeys,
    pod_list: data,
  });

  if (response.isSuccess) {
    dispatch({
      type: SET_INVOICE_NUMBER_POD_LIST,
      data,
    });
    message.success('POD updated successfully');
    dispatch(getInvoiceConsignmentList({
      type: deliveryAcknowledgement.searchType,
      number: deliveryAcknowledgement.invoiceNumber,
    }));
  } else {
    message.error(response.errorMessage);
    dispatch({
      type: SET_UPLOAD_FILE_LOADER,
      data: false,
    });
  }
};

export const uploadFilesAndSavePOD = (data) => async (dispatch, getState) => {
  dispatch({
    type: SET_UPLOAD_FILE_LOADER,
    data: true,
  });

  const urlList = await uploadPodFiles(data);

  if (urlList.length) {
    dispatch(updateInvoicePodList(urlList));
  }
};

export const fetchInvoiceNumbers = (data) => async (dispatch, getState) => {
  dispatch({
    type: SET_INVOICE_NUMBER_LOADER,
    data: true,
  });

  const response = await GET(
    `${API_BASE_URL}${INVOICE_SEARCH}/?type=${data.type}&query=${encodeURIComponent(data.query)}`,
  );

  if (response.isSuccess) {
    dispatch({
      type: SET_INVOICE_NUMBER_DATA,
      data: response.data,
    });
  } else {
    dispatch({
      type: SET_INVOICE_NUMBER_LOADER,
      data: false,
    });
    message.error(response.errorMessage);
  }
};

export const fetchISTInvoiceNumbers = (data) => async (dispatch, getState) => {
  dispatch({
    type: SET_INVOICE_NUMBER_LOADER,
    data: true,
  });

  const response = await getInvoiceNumbersForIST(data);

  if (response.isSuccess) {
    dispatch({
      type: SET_INVOICE_NUMBER_DATA,
      data: response.data,
    });
  } else {
    dispatch({
      type: SET_INVOICE_NUMBER_LOADER,
      data: false,
    });
    message.error(response.errorMessage);
  }
};

export const markCNsAsDelivered = (data?) => async (dispatch, getState) => {
  const { deliveryAcknowledgement } = getState();

  dispatch({
    type: SET_INVOICE_REQUEST_LOADER,
    data: true,
  });

  const pieceLevelActionsToUse = data?.pieceLevelActions
    || deliveryAcknowledgement.pieceLevelActions
    || {};
  const eventTimeToUse = data?.eventTime || null;
  const proofImageList = data?.proof_image_list || null;

  const pieceStatusList = Object.keys(pieceLevelActionsToUse)
    ?.map((key) => {
      const pieceDetail = pieceLevelActionsToUse[key] || {};
      const delivered = pieceDetail?.status === 'delivered';
      const payload: any = {
        reference_number: key,
        delivered,
        proof_image_list: pieceDetail?.pod,
      };
      if (pieceDetail?.failure_reason) {
        payload['failure_reason'] = pieceDetail.failure_reason;
        payload['failure_reason_id'] = pieceDetail.failure_reason_id;
      }
      if (pieceDetail?.comment) {
        payload['comment'] = pieceDetail.comment;
      }
      if (delivered && pieceDetail?.quantity_delivered) {
        payload['quantity'] = pieceDetail.quantity_delivered;
      }
      return payload;
    });

  const requestBody: any = {
    reference_number_list: deliveryAcknowledgement.selectedRowKeys,
    piece_status_list: pieceStatusList,
    event_time: eventTimeToUse || (
      deliveryAcknowledgement.eventTimestamp?.date && deliveryAcknowledgement.eventTimestamp?.time
        ? `${deliveryAcknowledgement.eventTimestamp.date} ${deliveryAcknowledgement.eventTimestamp.time}`
        : null
    ),
  };
  if (proofImageList) {
    requestBody.proof_image_list = proofImageList;
  }

  const response = await POST(API_BASE_URL + MARK_CONSIGNMENT_DELIVERED, requestBody);
  if (response.isSuccess) {
    dispatch(getInvoiceConsignmentList({
      type: deliveryAcknowledgement.searchType,
      number: deliveryAcknowledgement.invoiceNumber,
    }));
  } else {
    message.error(response.errorMessage);
    dispatch({
      type: SET_INVOICE_REQUEST_LOADER,
      data: false,
    });
  }
  return response;
};

export const markCNsAsDeliveredIST = () => async (dispatch, getState) => {
  const { deliveryAcknowledgement } = getState();

  dispatch({
    type: SET_INVOICE_REQUEST_LOADER,
    data: true,
  });
  const data = {
    reference_number_list: deliveryAcknowledgement.selectedRowKeys,
  };
  const response = await markConsignmentsAsDeliveredForIST(data);
  if (response.isSuccess) {
    dispatch(getInvoiceConsignmentList({
      type: deliveryAcknowledgement.searchType,
      number: deliveryAcknowledgement.invoiceNumber,
    }));
  } else {
    message.error(response.errorMessage);
    dispatch({
      type: SET_INVOICE_REQUEST_LOADER,
      data: false,
    });
  }
};

export const markCNsAsUndelivered = (data) => async (dispatch, getState) => {
  const { deliveryAcknowledgement } = getState();

  dispatch({
    type: SET_INVOICE_REQUEST_LOADER,
    data: true,
  });
  const requestBody = {
    reference_number_list: deliveryAcknowledgement.selectedRowKeys,
  };
  if (data?.reasonId) {
    requestBody['failure_reason_id'] = data.reasonId;
    requestBody['failure_reason'] = data.reasonName;
  }
  if (data?.comment) {
    requestBody['notes'] = data.comment;
  }
  const response = await POST(API_BASE_URL + MARK_CONSIGNMENT_UNDELIVERED, requestBody);
  if (response.isSuccess) {
    dispatch(getInvoiceConsignmentList({
      type: deliveryAcknowledgement.searchType,
      number: deliveryAcknowledgement.invoiceNumber,
    }));
  } else {
    message.error(response.errorMessage);
    dispatch({
      type: SET_INVOICE_REQUEST_LOADER,
      data: false,
    });
  }
};

export const markCNsAsUndeliveredIST = () => async (dispatch, getState) => {
  const { deliveryAcknowledgement } = getState();

  dispatch({
    type: SET_INVOICE_REQUEST_LOADER,
    data: true,
  });
  const data = {
    reference_number_list: deliveryAcknowledgement.selectedRowKeys,
  };
  const response = await markConsignmentsAsUndeliveredForIST(data);
  if (response.isSuccess) {
    dispatch(getInvoiceConsignmentList({
      type: deliveryAcknowledgement.searchType,
      number: deliveryAcknowledgement.invoiceNumber,
    }));
  } else {
    message.error(response.errorMessage);
    dispatch({
      type: SET_INVOICE_REQUEST_LOADER,
      data: false,
    });
  }
};

export const markCNsAsPickedUp = (data?) => async (dispatch, getState) => {
  const { deliveryAcknowledgement } = getState();

  dispatch({
    type: SET_INVOICE_REQUEST_LOADER,
    data: true,
  });

  const pieceLevelActionsToUse = data?.pieceLevelActions
    || deliveryAcknowledgement.pieceLevelActions
    || {};
  const eventTimeToUse = data?.eventTime || null;
  const proofImageList = data?.proof_image_list || null;

  const pieceStatusList = Object.keys(pieceLevelActionsToUse)
    ?.map((key) => {
      const pieceDetail = pieceLevelActionsToUse[key] || {};
      const pickupCompleted = pieceDetail?.status === 'pickup_completed';
      const payload: any = {
        reference_number: key,
        pickup_completed: pickupCompleted,
        proof_image_list: pieceDetail?.pod,
      };
      if (pieceDetail?.failure_reason) {
        payload['failure_reason'] = pieceDetail.failure_reason;
        payload['failure_reason_id'] = pieceDetail.failure_reason_id;
      }
      if (pieceDetail?.comment) {
        payload['comment'] = pieceDetail.comment;
      }
      if (pickupCompleted && pieceDetail?.quantity_pickedup) {
        payload['quantity'] = pieceDetail.quantity_pickedup;
      }
      return payload;
    });

  const requestBody: any = {
    reference_number_list: deliveryAcknowledgement.selectedRowKeys,
    piece_status_list: pieceStatusList,
    event_time: eventTimeToUse || (
      deliveryAcknowledgement.eventTimestamp?.date && deliveryAcknowledgement.eventTimestamp?.time
        ? `${deliveryAcknowledgement.eventTimestamp.date} ${deliveryAcknowledgement.eventTimestamp.time}`
        : null
    ),
  };
  if (proofImageList) {
    requestBody.proof_image_list = proofImageList;
  }

  const response = await POST(API_BASE_URL + MARK_CONSIGNMENT_PICKUP_COMPLETED, requestBody);
  if (response.isSuccess) {
    dispatch(getInvoiceConsignmentList({
      type: deliveryAcknowledgement.searchType,
      number: deliveryAcknowledgement.invoiceNumber,
    }));
  } else {
    message.error(response.errorMessage);
    dispatch({
      type: SET_INVOICE_REQUEST_LOADER,
      data: false,
    });
  }
  return response;
};

export const markCNsAsNotPickedUp = (data) => async (dispatch, getState) => {
  const { deliveryAcknowledgement } = getState();

  dispatch({
    type: SET_INVOICE_REQUEST_LOADER,
    data: true,
  });
  const requestBody = {
    reference_number_list: deliveryAcknowledgement.selectedRowKeys,
  };
  if (data?.reasonId) {
    requestBody['failure_reason_id'] = data.reasonId;
    requestBody['failure_reason'] = data.reasonName;
  }
  if (data?.comment) {
    requestBody['notes'] = data.comment;
  }
  const response = await POST(API_BASE_URL + MARK_CONSIGNMENT_NOT_PICKED_UP, requestBody);
  if (response.isSuccess) {
    dispatch(getInvoiceConsignmentList({
      type: deliveryAcknowledgement.searchType,
      number: deliveryAcknowledgement.invoiceNumber,
    }));
  } else {
    message.error(response.errorMessage);
    dispatch({
      type: SET_INVOICE_REQUEST_LOADER,
      data: false,
    });
  }
};

export const filterCnData = (data) => async (dispatch, getState) => {
  const { deliveryAcknowledgement } = getState();
  const { consignments } = deliveryAcknowledgement;
  let filteredConsignments = [];
  if (!data) {
    filteredConsignments = [...consignments];
  } else {
    filteredConsignments = consignments.filter(
      (cn) => cn.reference_number.toLowerCase().includes(data.toLowerCase()),
    );
  }
  dispatch({
    type: SET_FILTERED_INVOICE_CNS,
    data: filteredConsignments,
  });
};
